
(function() {
  var style = document.createElement("style");
  style.textContent = "@keyframes atcspin{to{transform:rotate(360deg)}}";
  document.head.appendChild(style);

  document.addEventListener("click", function(e) {
    var btn = e.target.closest("[data-quick-buy], [data-product-atc], .product-form--atc-button, button[type=submit][name=add]");
    if (!btn || btn.disabled) return;

    var origBg = btn.style.backgroundColor || "";
    var origColor = btn.style.color || "";
    var origHtml = btn.innerHTML;

    /* Phase 1: Teal with spinner */
    btn.style.backgroundColor = "#028a7e";
    btn.style.color = "#fff";
    btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;"><span style="display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,0.3);border-top:2px solid #fff;border-radius:50%;animation:atcspin 0.6s linear infinite;"></span> Adding...</span>';

    /* Phase 2: Teal with tick - stays 5 seconds */
    setTimeout(function() {
      btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:6px;">Added to Basket <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg></span>';

      /* Phase 3: Revert */
      setTimeout(function() {
        btn.style.backgroundColor = origBg;
        btn.style.color = origColor;
        btn.innerHTML = origHtml;
      }, 5000);
    }, 1500);
  });
})();
